<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Delete FTP Account</template>
    <template v-slot:body>
      <p class="mb-2">Delete account <strong>{{ account.user }}</strong>?</p>
      <p class="mb-2"><v-icon small class="pb-1">mdi-folder-outline</v-icon> {{ account.dir }}</p>
      <v-checkbox label="Delete the User’s Home Directory"
                  color="green"
                  v-model="destroy"
                  class="mt-1"
                  hide-details></v-checkbox>
      <v-alert type="warning"
               color="orange darken-1"
               :value="destroy"
               transition="slide-y-transition"
               class="py-1">
        Please ensure that no other users on this account require these files. This option will permanently remove
        all files in the following directory: <strong>{{ account.dir }}</strong>
      </v-alert>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn primary :loading="loading" @click="deleteAccount">Delete</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteModal',
  props: {
    account: {
      type: Object,
      required: true,
    },
    opened: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
      destroy: false,
    }
  },
  computed: {
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    },
  },
  methods: {
    ...mapActions({
      deleteFtpAccount: 'ftp/deleteFtpAccount',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    close () {
      this.$emit('close')
    },
    async deleteAccount () {
      this.loading = true
      const destroy = this.destroy ? '1' : '0'
      try {
        await this.deleteFtpAccount({
          ...this.account,
          destroy,
          _username: this.$route.query.user,
        })
        this.reportSuccess(`FTP Account “${this.account.user}” deleted.`)
        this.$emit('account-deleted')
        this.close()
      } catch (e) {
        this.reportError(e)
        this.loading = false
        this.close()
        this.$emit('failed')
      }
    },
  },
}
</script>
